<template>
  <div id="inventmentAllocation" class="inventmentAllocations">
    <div
      class="inventmentAllocations__title mt_15"
      :style="`background-color:#E5F6EC;border:1px solid #53c480`"
    >
      <div class="inventmentAllocations__title--title mr_10">帳戶比例配置</div>
      <div class="inventmentAllocations__title--subtitle">
        {{ `配置比例至少為0%，需以${fund_rato}%為單位，且合計需為100%。` }}
      </div>
    </div>
    <div
      class="inventmentAllocations__head"
      :style="`background-color:#E5F6EC;border:1px solid #53c480`"
    >
      <div>帳戶種類</div>
      <div>比例</div>
      <div>回饋分享金給付帳戶</div>
    </div>
    <div
      class="inventmentAllocations__body"
      v-for="(target, index) in inventmentAllocation"
      :key="target.fund_id"
    >
      <div>{{ target.fund_c_name }}</div>
      <div>
        <div class="d-flex align-items-center">
          <input
            type="text"
            maxlength="3"
            class="form-control mr_2"
            style="width: 4.5rem"
            :data-vv-name="target.fund_id"
            :class="{
              'is-invalid': errors.has(target.fund_id) && showError,
            }"
            v-validate.continues="`required|fund_proportion`"
            @input="ageFormat(target, 'fund_proportion')"
            @blur="showError = false"
            v-model.trim="target.fund_proportion"
          />
          %
        </div>
      </div>
      <!-- 回饋分享金給付帳戶 -->
      <div class="d-flex flex-nowrap justify-content-around">
        <select
          v-if="target.dvd_kind_opt != ''"
          :id="`bonus-acc`"
          class="form-control"
          style="width: 8rem"
          data-vv-as="回饋分享金給付帳戶"
          :data-vv-name="`bonus-acc`"
          v-validate="target.fund_proportion*1 !== 0 ? 'required' : ''"
          :class="{ 'is-invalid': errors.has(`bonus-acc`) }"
          v-model.trim="target.dvd_kind"
        >
          <option value="" disabled>請選擇</option>
          <option
            v-for="(item, index) in dvd_kind_list(target)"
            :key="index + 1"
            :value="item.paraval"
          >
            {{ item.paradetlno }}
          </option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
import { Validator } from "vee-validate";
import mf_Mixin from "@/desktop/views/mf/mixin";
import _ from "lodash";

export default {
  props: {
    inventmentAllocationProp: {
      type: Array,
      default: () => [],
    },
    validTotal100Text: {
      type: String,
      default: "",
    },
  },
  mixins: [mf_Mixin],
  data() {
    return {
      inventmentAllocation: _.cloneDeep(this.inventmentAllocationProp),
      checkTotal100: false,
      showError: false,
      fund_rato: 0,
    };
  },
  computed: {
    MfEditing() {
      return this.$store.getters.MfEditing;
    },
    PRODUCT_FEATURE_DATA() {
      return this.MfEditing.mc_prod_list[0].FEATURE_DATA;
    },
  },
  created() {
    this.init();
  },

  methods: {
    init() {
      Validator.extend(`fund_proportion`, {
        getMessage: "",
        validate: (value) => {
          this.inventmentAllocation.reduce((accumulator, currentObj) => {
            return accumulator + currentObj.fund_proportion * 1;
          }, 0);
          return (
            value % this.fund_rato == 0 &&
            value * 1 >= 0 &&
            this.inventmentAllocation.reduce((accumulator, currentObj) => {
              return accumulator + currentObj.fund_proportion * 1;
            }, 0) == 100
          );
        },
      });
      //一般標的投資比重%數
      let rato = this.PRODUCT_FEATURE_DATA.fund_rato;
      this.fund_rato = parseInt(rato);
    },

    dvd_kind_list(target) {
      let optionList = [];
      if (target.dvd_kind == null) {
        this.$set(target, "dvd_kind", "");
      }
      let dvd_array = target.dvd_kind_opt.split(",");
      if (dvd_array.length === 1) {
        target.dvd_kind = dvd_array[0];
      }
      this.$paragrpno.dvd_kind.filter((item) => {
        dvd_array.filter((element) => {
          if (element === item.paraval) {
            optionList.push(item);
          }
        });
      });
      return optionList;
    },

    async validateAll() {
      this.showError = true;
      let valid = await this.$validator.validateAll();
      const errors = this.$validator.errors.items;
      const hasFundProportionError = errors.some(
        (err) => err.rule === "fund_proportion"
      );
      if (
        this.inventmentAllocation.some((item) => {
          //return !item.fund_proportion || item.fund_proportion == 0;
          return !item.fund_proportion;
        })
      ) {
        this.$toast.info({
          title: "配置比例不得為空。",
        });
        valid = false;
      }
      if (hasFundProportionError) {
        this.$toast.info({
          title:
            this.validTotal100Text ||
            `配置比例需以${this.fund_rato}%為單位，且固定帳戶及指定帳戶配置比例分開計算，各自合計需為100%!`,
        });
        valid = false;
      }
      return valid;
    },
  },
  watch: {
    inventmentAllocation: {
      handler(newVal) {
        this.$emit("update:inventmentAllocationProp", _.cloneDeep(newVal));
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.inventmentAllocations {
  max-width: 980px;
  &__title {
    width: 100%;
    height: 50px;
    padding: 0 15px;
    border-radius: 4px;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.16);
    border: solid 1px #53c480;
    background-color: #e5f6ec;
    display: flex;
    align-items: center;
    font-size: 16px;
    &--title {
      font-weight: 700;
      text-align: center;
      color: #323a45;
    }
    &--subtitle {
      font-size: 13px;
      text-align: center;
      color: #de4054;
      &--nap {
        font-size: 13px;
        text-align: center;
        color: #de4054;
      }
    }
  }
  &__head {
    font-weight: 700;
    width: 100%;
    height: 50px;
    border-radius: 4px;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.16);
    border: solid 1px #53c480;
    background-color: #e5f6ec;
    display: flex;
    align-items: center;
    text-align: center;
    font-size: 16px;
    padding: 0 15px;
    & > div:nth-of-type(1) {
      width: 45%;
      text-align: center;
    }
    & > div:nth-of-type(2) {
      width: 10%;
    }
    & > div:nth-of-type(3) {
      flex: 1;
    }
    & > div:nth-last-child(1) {
      width: 45%;
      text-align: center;
    }
  }
  &__body {
    display: flex;
    align-items: center;
    text-align: center;
    border-radius: 4px;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.16);
    border: solid 1px #c2c4c7;
    padding: 0 15px;

    &:nth-of-type(odd) {
      background-color: #f5f5f5;
    }
    & > div {
      padding: 6px 12px;
    }
    & > div:nth-of-type(1) {
      width: 45%;
      padding: 6px 0;
      text-align: center;
    }
    & > div:nth-of-type(2) {
      width: 10%;
      text-align: center;
      padding: 6px 20px;
    }
    & > div:nth-of-type(3) {
      flex: 1;
    }
    & > div:nth-last-child(1) {
      width: 45%;
      text-align: center;
    }
  }
}
</style>
